import { Flex, theme, Typography } from '@styles';
import { number, oneOf, oneOfType, string } from 'prop-types';
import React from 'react';

import { Icon } from '../Icon';
import { tagLayoutByVariant } from './Tag.layoutProps';

const Tag = ({ content, variant }) => {
  const tagProps = tagLayoutByVariant[variant];

  return (
    <Flex
      alignItems="center"
      bg={theme.colors.schoolBusYellow[10]}
      borderRadius={4}
      flexDirection="row"
      px={2}
      py={1}
      width="fit-content"
    >
      <Icon height={16} mr={2} SVG={tagProps.svg} width={16} />
      <Typography
        color={theme.colors.schoolBusYellow[100]}
        variant="MS-regular-s14-lh22"
      >
        {content}
      </Typography>
    </Flex>
  );
};

Tag.propTypes = {
  content: oneOfType([string, number]).isRequired,
  variant: oneOf(['material', 'peoplePassed', 'test', 'time', 'attitude'])
    .isRequired,
};

export default Tag;
